import { Injectable } from '@angular/core';
import { toPng } from 'html-to-image';

@Injectable({
  providedIn: 'root',
})
export class PrintServicesService {
  constructor() {}

  print(element) {
    const content = window.open('', 'PRINT', 'noopener,noreferrer');
    const styles = `
    img{
      width: 80px;
    }
    footer{
      display: none;
    }
    hr{
      border: 0px;
      height: 2px;
      background: grey;
    }
    a, button{
      display: none;
    }
    `;
    content.document.write(`<style>${styles}</style>`);
    content.document.write('</head><body>');
    content.document.write(element);
    content.document.write('</body></html>');
    content.document.close();
    content.focus();
    content.print();
    content.close();
    return true;
  }

  downloadImage(element, name: string) {
    toPng(element, { quality: 1 }).then(dataUrl => {
      const link = document.createElement('a');
      link.download = `${name}.png`;
      link.href = dataUrl;
      link.click();
    });
  }
}
